<div class="account-empty">

    <div class="account-empty__thumb">                                 
       <picture>
          <source media="(min-width: 768px)" srcset="/assets/img/better-deal-lg.svg">
          <source srcset="/assets/img/better-deal.svg">
          <img src="/assets/img/better-deal-lg.svg" class="img-fluid">
       </picture>
    </div>
    
    <div class="account-empty__content">
       <h3 class="mb-20">Create a Better Deal Alert</h3>
       <div class="rte mb-30">
          <p class="font-16">Be the first to know of better deals on your cover! Insurance products change all the time. We can let you know next time there is a better deal for your cover.</p>
       </div>
    </div>

    <div class="account-empty__btn">
       <a href="#" class="button button--lg button--primary">Get a Quote</a>
    </div>
    

 </div>